import { GeoBounded } from "../geography.envelope";
export class GeoShape extends GeoBounded {
    constructor(t) {
        super();
        this._type = t;
    }
    get type() {
        return this._type;
    }
}
//# sourceMappingURL=geography.shape.js.map